import { useState } from "react";
import { StyledFeaturedWebinars, featuredWebinarsClasses } from "./StyledFeaturedWebinars";
import { Grid, Typography, Button, Box } from "@mui/material";
import { primary } from "../../common/theme";
import { webinars, IWebinar } from "../../VideoTelling/Data/webinars-data";
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import PlayCircleFilledWhiteIcon from '@mui/icons-material/PlayCircleFilledWhite';
import YouTubeModal from "../../Components/YouTubeModal";

export const FeaturedWebinars = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const youtubeId = "BEi8p9Rivsg";

  // Fetch webinar by youtubeId, get the first that matches
  const getWebinar = (): IWebinar | undefined => {
    return webinars.find(webinar => webinar.youtubeId === youtubeId);
  };

  const featuredWebinar = getWebinar();

  if (!featuredWebinar) {
    return null;
  }

  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  return (
    <StyledFeaturedWebinars className={featuredWebinarsClasses.root}>
      <YouTubeModal 
        isOpen={modalIsOpen} 
        videoId={featuredWebinar.youtubeId} 
        onClose={closeModal} 
      />
      <Grid container spacing={4} sx={{ marginTop: "40px", marginBottom: "40px" }}>
        {/* Left side - Details */}
        <Grid item xs={12} md={6}>
          <Typography 
            variant={"h1"} 
            component="div" 
            sx={{
              color: primary, 
              marginBottom: "30px", 
              fontSize: "50px",
              lineHeight: "60px",
              fontWeight: "700"
            }}
          >
            Featured Webinar
          </Typography>

          <Typography 
            variant="h2"
            component="div"
            sx={{
              color: primary,
              fontSize: "24px",
              fontWeight: "bold",
              marginBottom: "20px",
              lineHeight: "30px"
            }}
          >
            {featuredWebinar.description}
          </Typography>

          <Box sx={{ display: "flex", alignItems: "center", marginBottom: "20px", gap: "10px" }}>
            <Button
              variant="contained"
              onClick={openModal}
              sx={{
                backgroundColor: primary,
                color: "white",
                "&:hover": {
                  backgroundColor: primary,
                  opacity: 0.9
                }
              }}
              startIcon={<PlayCircleFilledWhiteIcon />}
            >
              Watch Video
            </Button>

            <HourglassBottomIcon htmlColor={primary} />
            <Typography sx={{ color: primary, fontSize: "16px" }}>
              {featuredWebinar.watchTime}
            </Typography>
          </Box>
        </Grid>

        {/* Right side - Video Thumbnail */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              cursor: "pointer",
              "&:hover": {
                opacity: 0.9
              },
              backgroundColor: "black",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "8px",
              overflow: "hidden",
            }}
            onClick={openModal}
          >
            <img
              src={featuredWebinar.image}
              alt={featuredWebinar.imagealt}
              style={{
                maxWidth: "100%",
                maxHeight: "100%",
                display: "block"
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </StyledFeaturedWebinars>
  );
};

